import {get} from 'lodash';

export default (state = {}, {customer_id, data}: any) => {
  return {
    ...state,
    allMwlData: {
      ...get(state, 'allMwlData', {}),
      [customer_id]: data,
    },
  };
};
